import { RootState } from "store/index";
import { createSelector } from "@reduxjs/toolkit";
import { UserGroupCategory, UserGroupKey } from "client/jspPlatformExperiment";
import { SITE_COLORS } from "store/slices/userGroup/userGroupOptionsSlice";

const userGroupOptions = (state: RootState): Record<number, UserGroupKey> =>
  state.userGroupOptions.data;

const siteUserGroupOptions = createSelector(
  [userGroupOptions],
  (data): Record<number, UserGroupKey> => {
    const result: Record<number, UserGroupKey> = {};
    Object.entries(data).forEach(([key, value]) => {
      if (value.group_category === UserGroupCategory.SITE) {
        result[Number(key)] = value;
      }
    });
    return result;
  },
);

const siteOptionIDs = createSelector(
  [siteUserGroupOptions],
  (siteOptions): number[] =>
    Object.values(siteOptions).map((value) => value.id),
);

const siteColorMap = createSelector(
  [siteOptionIDs],
  (ids): Record<number, string> => {
    const result: Record<number, string> = {};
    ids.forEach((id, index) => {
      result[id] = SITE_COLORS[index % SITE_COLORS.length];
    });
    return result;
  },
);

export default {
  userGroupOptions,
  siteUserGroupOptions,
  siteOptionIDs,
  siteColorMap,
};
